import Button from '@eversports/klimt-primitives/legacy/Button'
import Icon from '@eversports/klimt-primitives/legacy/Icon'
import Link from '@eversports/klimt-primitives/legacy/Link'
import Stack from '@eversports/klimt-primitives/legacy/Stack'
import Text from '@eversports/klimt-primitives/legacy/Text'

import ErrorIcon from '../../assets/icons/error.svg'
import useGetTopContentHeight from '../../hooks/useGetTopContentHeight'
import { Localized } from '../../localization/react'

const Forbidden = () => {
  const { DESKTOP_TOP_CONTENT_HEIGHT: TOP_CONTENT_HEIGHT } = useGetTopContentHeight(['NAVIGATION_BAR'])
  return (
    <Stack
      sx={{
        backgroundColor: 'eggshell',
        height: `calc(100vh - ${TOP_CONTENT_HEIGHT}px)`,
        justifyContent: 'center',
        alignItems: 'center',
      }}
      component="main"
    >
      <Stack gap={4} paddingX={4} alignItems="center" justifyContent="center" data-testid="error">
        <Icon src={ErrorIcon} size="x-large" color="red" />
        <Text variant="large" sx={{ textAlign: 'center', fontWeight: 'bold' }}>
          <Localized id="forbidden-error-message" />
        </Text>
        <Link to="/">
          <Button variant="primary" sx={{ px: 2, py: 1 }}>
            <Text variant="badge" sx={{ color: 'white' }}>
              <Localized id="back-to-home" />
            </Text>
          </Button>
        </Link>
      </Stack>
    </Stack>
  )
}

export default Forbidden
